import Vue from "vue";

const state = Vue.observable({
  activeEvent: {

  },
  schedule: {
    events: []
  },
  chat: {
    chatroomActive: false,
    activeChatroom: null,
    chatrooms: new Map(),
    activators: null
  },

});

export default state;

export function setActiveViewEvent(_event) {
  if (!_event) { return null }

  const event = { ..._event.originalEvent };
  activateChatroom(event.chatActivators);
}

export function activateChatroom(chatActivators) {
  state.chat.chatroomActive = true;
  state.chat.activators = chatActivators;
}
